import './style.scss'
import React from 'react'
import { Box, tokens, UIProps } from 'src/componentv2/Base/ui'

export interface CardProps extends UIProps {
    children?: React.ReactNode
    onClick?: () => void
    style?: React.CSSProperties
}
export const Card: React.FC<CardProps> = ({
                                              children, className = '',
                                              bgColor = tokens.white,
                                              borderColor = tokens.border,
                                              radius = '1.2',
                                              padding = '1.6',
                                              shadow = tokens.shadowCard,
                                              ...rest
                                          }) => (
    <Box
        className={`card ${className}`}
        bgColor={bgColor}
        borderColor={borderColor}
        radius={radius}
        padding={padding}
        shadow={shadow}
        {...rest}
    >
        {children}
    </Box>
)

export default Card